import type { AllRouteEndpoints } from "../routeTypes";
export const appsUserInfoCancelUserDeletionCacheKeys: AllRouteEndpoints[] = [];
